<dx-popup #dlgTillDiscrepancy [width]="600" [height]="400" [showTitle]="true" title="Cash Up Discrepancy"
    [resizeEnabled]=false [dragEnabled]="true" [showCloseButton]="false" [hideOnOutsideClick]="false"
    (onInitialized)="onInit($event)" (onShown)="onShown($event)">

    <dxi-toolbar-item widget="dxButton" toolbar="bottom" location="after" [options]="OKButtonOptions">
    </dxi-toolbar-item>

    <div *dxTemplate="let data of 'content'">
        <dx-form [formData]="cashUpInfo" labelLocation="top">
            <dxi-item itemType="simple">
                {{this.cashUpInfo.DiscrepancyText}}
            </dxi-item>
            <dxi-item dataField="DiscrepancyReason" caption="Discrepancy Reason" editorType="dxTextArea"
                [editorOptions]="{ height:150 }">
                <dxi-validation-rule #vgReason type="required"
                    [message]="constants.RequiredFieldMessage('cashup','discrepancy reason')">
                </dxi-validation-rule>
            </dxi-item>
        </dx-form>
    </div>
</dx-popup>